const ErrorIcon = ({ className = '', ...otherProps }) => (
  <svg
    className={className}
    width='121'
    height='121'
    viewBox='0 0 121 121'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...otherProps}
  >
    <circle
      cx='60.7262'
      cy='60.3341'
      r='47.3268'
      fill='#FA8366'
      stroke='#E35B3A'
      strokeWidth='3'
    />
    <path
      d='M62.312 34.1265H58.688C56.2806 34.1265 54.3651 35.8739 54.5075 37.9324L56.6171 69.4017C56.7336 71.1492 58.4291 72.5265 60.5 72.5265C62.5709 72.5265 64.2275 71.1492 64.3829 69.4017L66.4925 37.9324C66.6349 35.8739 64.7194 34.1265 62.312 34.1265Z'
      fill='white'
    />
    <path
      d='M54.5 80.9265C54.5 81.7144 54.6552 82.4947 54.9567 83.2226C55.2583 83.9506 55.7002 84.612 56.2574 85.1692C56.8145 85.7263 57.4759 86.1683 58.2039 86.4698C58.9319 86.7713 59.7121 86.9265 60.5 86.9265C61.2879 86.9265 62.0681 86.7713 62.7961 86.4698C63.5241 86.1683 64.1855 85.7263 64.7426 85.1692C65.2998 84.612 65.7417 83.9506 66.0433 83.2226C66.3448 82.4947 66.5 81.7144 66.5 80.9265C66.5 80.1386 66.3448 79.3584 66.0433 78.6304C65.7417 77.9025 65.2998 77.241 64.7426 76.6839C64.1855 76.1267 63.5241 75.6848 62.7961 75.3832C62.0681 75.0817 61.2879 74.9265 60.5 74.9265C59.7121 74.9265 58.9319 75.0817 58.2039 75.3832C57.4759 75.6848 56.8145 76.1267 56.2574 76.6839C55.7002 77.241 55.2583 77.9025 54.9567 78.6304C54.6552 79.3584 54.5 80.1386 54.5 80.9265Z'
      fill='white'
    />
    <circle
      cx='60.5'
      cy='60.1265'
      r='59'
      stroke='#F96440'
      strokeWidth='2'
      strokeDasharray='4 4'
    />
  </svg>
)

export default ErrorIcon
